module.exports = __webpack_public_path__ + "media/1x1/my-263aea34.svg";